module.exports = __webpack_public_path__ + "static/media/MapView.ae37dd40.svg";